import BaseComponent from "../base-component.js";
import { h } from "preact";

export default class OrderingReportComponent extends BaseComponent {
    responseCollector() {
        let choices = this.props.item.responseDeclaration.choices;
        if (!choices) return null;

        /**
         * @type {Object<number, import("../../shared-types.js").ItemChoice>}
         */
        let choicesById = choices.reduce((acc, choice) => {
            acc[Number(choice.id)] = choice;
            return acc;
        }, {});


        let studentResponse = this.props.studentResponse?.ordering || { ordered_choice_ids: [] }
        let unplacedChoices = choices.filter((choice) => studentResponse.ordered_choice_ids.indexOf(Number(choice.id)) == -1).sort((a, b) => a.ordinal - b.ordinal);

        return (
            <div class="response-collector">
                <div className="ordering-match-container">
                    {studentResponse.ordered_choice_ids.map((id, index) => {
                        let choice = id !== null ? choicesById[Number(id)] : null;
                        return (
                            <div className="ordering-row">
                                <div className="ordering-target" data-index={index}>
                                    {choice ? <div
                                        key={choice.id}
                                        id={`ordering-choice-${choice.id}`}
                                        data-id={choice.id}
                                        className="ordering-choice"
                                    >
                                        <div
                                            class="ordering-choice-content"
                                            dangerouslySetInnerHTML={{ __html: choice.body }}
                                        ></div>
                                    </div> : null}

                                </div>
                            </div>
                        );
                    })}
                </div>
                <div className="ordering-choice-container">
                    {unplacedChoices.map((choice) => {
                        return (
                            <div
                                key={choice.id}
                                id={`ordering-choice-${choice.id}`}
                                data-id={choice.id}
                                className="ordering-choice"
                            >
                                <div
                                    class="ordering-choice-content"
                                    dangerouslySetInnerHTML={{ __html: choice.body }}
                                ></div>
                            </div>
                        );
                    }) || []}
                </div>
            </div>
        );
    }

    render() {
        return this.wrapper(this.body(), this.responseCollector());
    }
}